import AvailabilityNotificationPopup from 'containers/MapDetails/popups/AvailabilityNotificationPopup'
import { selectPlaceData } from 'containers/MapDetails/placeSlice'
import usePlaceFilters from './hooks/usePlaceFilters'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { useReduxSelector } from 'store'
import type { Size } from './Header'
import React from 'react'

interface AvailabilityPopupState {
  type: 'availability'
  props: {
    name: string
    groupHash: string
    variantHash?: string
  }
}

interface UnavailablePopupProps {
  isOpen: boolean
  close: () => void
}

const UnavailablePopup: React.FC<UnavailablePopupProps> = ({ isOpen, close }) => {
  const place = useReduxSelector(selectPlaceData)
  const [filters, setFilters] = usePlaceFilters()
  const { popup, openPopup } = usePopupState<AvailabilityPopupState>()

  const { replace } = useHistory()
  const { t } = useTranslation('placeMap')

  const warehouseTypeId: string | undefined = filters?.attributes?.warehouseTypeId
  const variants = warehouseTypeId ? place?.warehouses?.[warehouseTypeId] : undefined
  // Powiadomienie wymaga wariantu - jeśli nie jest wybrany w filtrach, bierzemy pierwszy z danego rozmiaru
  const variantHash: string | undefined = filters?.attributes?.hash || Object.keys(variants || {})[0]
  const size: Size | undefined = place?.sizes?.find((size: Size) => size.warehouseTypeId === warehouseTypeId)
  const name = variantHash && variants?.[variantHash]
    ? `${variants[variantHash].warehouseTypeName} - ${variants[variantHash].name}`
    : size?.name || ''

  return (
    <>
      {isOpen && <Popup
        isPopup
        centered
        isLine={false}
        close={close}>
        <div className='placeMap__unavailable'>
          <div className='popup__title'>
            <i className='icon icon--logo s24' />
            <div>{t(warehouseTypeId ? 'warehousesOfThisSizeAreNoLongerAvailable' : 'noWarehousesAvailableInThisLocation')}</div>
          </div>

          <div className='popup__buttons'>
            {warehouseTypeId
              ? <>
                <ArrowBtn
                  enlarged
                  showArrow={false}
                  text={t('seeTheRest')}
                  action={() => {
                    close()
                    const { hash, warehouseTypeId, ...attributes } = filters?.attributes || {}
                    setFilters({ ...filters, attributes })
                  }}
                />
                <button
                  type='button'
                  className='button placeMap__unavailable__secondary'
                  onClick={() => {
                    close()
                    openPopup({
                      type: 'availability',
                      props: { name, groupHash: warehouseTypeId, variantHash }
                    })
                  }}>
                  {t('notifyAboutAvailability')}
                </button>
              </>
              : <>
                <ArrowBtn
                  enlarged
                  showArrow={false}
                  text={t('chooseAnotherLocation')}
                  action={() => {
                    close()
                    replace('/home')
                  }}
                />
                <button
                  type='button'
                  className='button placeMap__unavailable__secondary'
                  onClick={close}>
                  {t('close')}
                </button>
              </>}
          </div>
        </div>
      </Popup>}

      {popup?.type === 'availability' && <AvailabilityNotificationPopup
        placeId={place?.id}
        companyName={place?.companyName}
        groupHash={popup.props.groupHash}
        variantHash={popup.props.variantHash || ''}
        name={popup.props.name}
      />}
    </>
  )
}

export default UnavailablePopup
